var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DcwScrollSnap',{staticClass:"dcw-jobs-wrapper",attrs:{"items":new Array(6),"is-list":false,"is-grid":"","item-class":"dcw-jobs-wrapper__item"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var index = ref.index;
return [(index === 0)?[_vm._t("cta")]:[_vm._t("default",null,{"offer":_vm.sortedOffersArray[index - 1]})]]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }